export enum KioskPostMessageEvent {
  RedirectToLandingPage = 'redirectToLandingPage',
  RedirectToThankYou = 'redirectToThankYou',
  Error = 'Could not post message to react native webView event',
}
